export const CARD_TONES = [
  {
    bg: "surface.white",
    isDark: false,
    accent: "brand.600",
    muted: "warm.600",
    included: "warm.600",
    excluded: "warm.600",
    excludedDot: "warm.300",
  },
  {
    bg: "warm.700",
    isDark: true,
    accent: "warm.300",
    muted: "warm.300",
    included: "rgba(245, 243, 240, 0.8)",
    excluded: "warm.300",
    excludedDot: "warm.500",
  },
  {
    bg: "surface.dark",
    isDark: true,
    accent: "ink.light2",
    muted: "ink.light2",
    included: "rgba(245, 243, 240, 0.6)",
    excluded: "warm.500",
    excludedDot: "warm.700",
  },
] as const;

export type CardTone = (typeof CARD_TONES)[number];
